import "../style.scss";

import DocumentationLink from "components/shared/DocumentationLink";
import ImageFormComponent from "components/shared/FormComponent/ImageFormComponent";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

import type { ITransfereeFormData } from "..";

interface INewTransfereeStep {
    stepTitle: string;
    stepSubtitle: string;
    mode: "new" | "edit-page";
    indexStep: number;
    useFormData: ITransfereeFormData;
}

/**
 * First step of TransfereeForm.
 */
const NewTransfereeStep = ({ stepTitle, stepSubtitle, mode, indexStep, useFormData }: INewTransfereeStep) => {
    const [t] = useTranslation();
    const { control, errors, watch, setValue } = useFormData;

    const { pictureStatus } = useAppSelector((state) => state.documents);

    return (
        <>
            <h3 className="form-section-title first">
                {" "}
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                <ImageFormComponent
                    label={mode === "new" ? t("NewBeneficiary.Photo") : ""}
                    avatar={watch("avatarUrl")}
                    setAvatar={setValue}
                    sendPictureStatus={pictureStatus}
                    control={control}
                    controlName="avatarUrl"
                    type={mode === "new" ? "new-beneficiary" : "beneficiary"}
                />
                <TextFormComponent
                    label={`${t("Transferees.TransfereeName")}`}
                    control={control}
                    controlName="name"
                    error={errors.name}
                    required
                />
                <TextFormComponent
                    label={t("Transferees.Email")}
                    control={control}
                    controlName="email"
                    error={errors.email}
                />
                <div className="joined-fields">
                    <TextFormComponent
                        label={t("Beneficiars.Siret")}
                        control={control}
                        controlName="siretNumber"
                        error={errors.siretNumber}
                    />
                    <TextFormComponent
                        label={t("Transferees.IntraCommunityTVA")}
                        control={control}
                        controlName="intraCommunityVat"
                        error={errors.intraCommunityVat}
                    />
                </div>
            </div>
        </>
    );
};

export default NewTransfereeStep;
